import { render, staticRenderFns } from "./CreateBulkPayment.vue?vue&type=template&id=21a5f2b2&"
import script from "./CreateBulkPayment.vue?vue&type=script&lang=js&"
export * from "./CreateBulkPayment.vue?vue&type=script&lang=js&"
import style0 from "./CreateBulkPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports